import { useInfiniteQuery } from '@tanstack/react-query';
import defaultFetch from 'react/api/sagas/fetch/defaultFetch';

async function getRouteView({ pageParam, ...payload }) {
  const criteriaParams = {
    filters: [
      'id',
      'route.id',
      'route.key',
      'route.date',
      'route.status',
      'route.totalStops',
      'route.plannedSize1',
      'route.plannedSize2',
      'route.plannedSize3',
      'route.canceledStops',
      'totalStopsInProgress',
      'route.redeliveredStops',
      'route.actualDepartures',
      'route.actualStart',
      'route.plannedStart',
      'route.projectedComplete',
      'route.plannedComplete',
      'route.undeliveredStops',
      'route.organization.description',
      'route.origin.description',
      'route.destination.description',
      'route.driverAssignments.id',
      'route.driverAssignments.driver.id',
      'route.driverAssignments.driver.key',
      'route.driverAssignments.driver.name',
      'route.driverAssignments.driver.driverType',
      'route.helperAssignments.id',
      'route.helperAssignments.helper.id',
      'route.helperAssignments.helper.key',
      'route.helperAssignments.helper.name',
      'route.equipmentAssignments.id',
      'route.equipmentAssignments.principal',
      'route.equipmentAssignments.equipment.id',
      'route.equipmentAssignments.equipment.key',
      'route.equipmentAssignments.equipment.equipmentType.size1',
      'route.equipmentAssignments.equipment.equipmentType.size2',
      'route.equipmentAssignments.equipment.equipmentType.size3',
      'route.equipmentAssignments.equipment.equipmentType.description'
    ],
    firstResult: pageParam === 0 ? 0 : pageParam * 51,
    maxResults: 51
  };

  const criteriaChain = {
    ...payload,
    sort: [
      {
        attr: 'route.date',
        type: 'DESC'
      },
      {
        attr: 'route.key',
        type: 'ASC'
      }
    ]
  };

  const criteria = JSON.stringify(criteriaParams);
  const url = `/RouteView/restrictions?criteria=${encodeURI(criteria)}`;
  const response = await defaultFetch(url, criteriaChain, 'POST');

  if (response.error) {
    throw new Error('Failed fetch');
  }

  return response;
}

export function useRouteView(payload, enabled = true) {
  const ONE_MINUTE_IN_MS = 1000 * 60;

  return useInfiniteQuery({
    queryKey: ['route-view', payload],
    initialPageParam: 0,
    staleTime: ONE_MINUTE_IN_MS,
    queryFn: async ({ pageParam }) => getRouteView({ pageParam, ...payload }),
    getNextPageParam: (lastPage, allPages) => (lastPage.length ? allPages.length : undefined),
    enabled
  });
}
